import { REPUVE_POSITIONS_ENUM } from './data';
import { LevelsEnum } from './levels';
import { MODULES_ENUM } from './modules';
import { PositionEnum } from './positions';

interface IDomain {
  menuName: string;
  menuIcon: string;
  url: string;
  idMenu: number[];
  open: boolean;
  idModules: MODULES_ENUM[];
  positionsId: PositionEnum[];
  repuvePositions?: REPUVE_POSITIONS_ENUM[];
  subMenu: any[];
  levels: LevelsEnum[];
}

export const DOMAIN_MENU: IDomain[] = [
  //* PERFIL
  {
    menuName: 'NAV.myProfile',
    menuIcon: 'ic-user',
    url: 'perfil/admin',
    idMenu: [0],
    open: false,
    idModules: [MODULES_ENUM.PROFILE],
    positionsId: [],
    subMenu: [],
    levels: [
      LevelsEnum.LEVEL_1,
      LevelsEnum.LEVEL_2,
      LevelsEnum.LEVEL_3,
      LevelsEnum.LEVEL_4,
    ],
  },
  {
    menuName: 'Resumen',
    menuIcon: 'ic-events-kpi',
    url: 'resumen',
    idMenu: [49],
    open: false,
    idModules: [],
    positionsId: [PositionEnum.Superadministrador],
    subMenu: [],
    levels: [LevelsEnum.LEVEL_1],
  },
  {
    menuName: 'Estadísticas',
    menuIcon: 'ic-statistics',
    url: 'estadisticas',
    idMenu: [55],
    open: false,
    idModules: [],
    positionsId: [PositionEnum.Superadministrador],
    subMenu: [],
    levels: [LevelsEnum.LEVEL_1],
  },
  {
    menuName: 'NAV.events',
    menuIcon: 'ic-events',
    url: 'eventos',
    idMenu: [7],
    open: false,
    idModules: [MODULES_ENUM.EVENTS],
    positionsId: [],
    subMenu: [],
    levels: [LevelsEnum.LEVEL_1, LevelsEnum.LEVEL_2, LevelsEnum.LEVEL_3],
  },
  {
    menuName: 'REPUVE',
    menuIcon: 'ic-repuve',
    url: '',
    idMenu: [56, 58],
    open: false,
    idModules: [],
    positionsId: [PositionEnum.Superadministrador, PositionEnum.REPUVE],
    subMenu: [
      {
        subMenuName: 'NAV.nationals',
        subMenuIcon: 'ic-nationals',
        url: 'repuve/nacionales',
        idMenu: 58,
        idModules: MODULES_ENUM.REPUVE
      },
      {
        // subMenuName: 'NAV.foregeiners',
        subMenuName: 'SCT',
        subMenuIcon: 'ic-nationals',
        url: 'repuve/extranjeros',
        idMenu: 56,
        idModules: MODULES_ENUM.REPUVE
      }
    ],
    levels: [LevelsEnum.LEVEL_1],
  },
  //* USUARIOS
  {
    menuName: 'NAV.users',
    menuIcon: 'ic-personal',
    url: 'usuarios',
    idMenu: [2],
    open: false,
    idModules: [1],
    positionsId: [],
    repuvePositions: [REPUVE_POSITIONS_ENUM.ADMIN],
    subMenu: [],
    levels: [LevelsEnum.LEVEL_1, LevelsEnum.LEVEL_2, LevelsEnum.LEVEL_3],
  },
  {
    menuName: 'Policía municipal',
    menuIcon: 'ic-municipal-police',
    url: 'policia-municipal',
    idMenu: [50],
    open: false,
    idModules: [],
    positionsId: [
      PositionEnum.Superadministrador,
      PositionEnum.PoliciaMunicipal,
      PositionEnum.Apozol,
      PositionEnum.Zacatecas,
    ],
    subMenu: [],
    levels: [LevelsEnum.LEVEL_1, LevelsEnum.LEVEL_2, LevelsEnum.LEVEL_3],
  },
  {
    menuName: 'Fiscalía',
    menuIcon: 'ic-prosecution',
    url: 'fiscalia-estatal',
    idMenu: [51],
    open: false,
    idModules: [],
    positionsId: [
      PositionEnum.Superadministrador,
      PositionEnum.FiscaliaGeneralDeJusticiaDelEstado,
      PositionEnum.PoliciaDeInvestigacion,
      PositionEnum.MPs,
      PositionEnum.Peritos,
    ],
    subMenu: [],
    levels: [LevelsEnum.LEVEL_1, LevelsEnum.LEVEL_2, LevelsEnum.LEVEL_3],
  },
  {
    menuName: 'SSP',
    menuIcon: 'ic-state-police',
    url: 'ssp',
    idMenu: [52],
    open: false,
    idModules: [],
    positionsId: [
      PositionEnum.Superadministrador,
      PositionEnum.SSPSecretariaSeguridadPublicaDelEstado,
      PositionEnum.PoliciaEstatal,
      PositionEnum.Custodios,
      PositionEnum.PoliciaVial,
    ],
    subMenu: [],
    levels: [LevelsEnum.LEVEL_1, LevelsEnum.LEVEL_2, LevelsEnum.LEVEL_3],
  },
];
